import logError from 'utils/errorLogger'

export const getHoverText = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        text: 'A nota fiscal foi criada e está em processo de emissão'
      }
    case 'issued':
      return {
        text: 'A nota fiscal foi criada e a emissão está agendada'
      }
    case 'confirmed':
      return {
        text: 'A nota fiscal foi emitida e confirmada'
      }
    case 'canceled':
      return {
        text: 'A nota fiscal foi cancelada'
      }
    case 'failed':
      return {
        text: 'Erro ao emitir a nota fiscal'
      }
    default:
      // Sem status a nota ainda está carregando: não é status desconhecido.
      if (status) {
        logError(
          `Erro ao mapear o texto da tooltip de notas fiscais: ${status}`
        )
      }
      return {
        text: 'Status desconhecido'
      }
  }
}
